import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactGA from 'react-ga4';
import { useParams } from 'react-router-dom';
import { academyDataActions } from '../../store/academy-slice';
// import { useTranslation } from 'react-i18next';

import Chip from '@mui/material/Chip';

import Loading from 'components/UI/Loading/Loading';
import CourseCard from '../../components/UI/CourseCard/CourseCard';
import MetadataModal from 'components/UI/MetadataModal/MetadataModal';

import { getCoursesByAcademy } from 'store/academy-actions';

import classes from './Home.module.css';

const Home = () => {
  // const { t } = useTranslation();
  const [openDialog, setOpenDialog] = useState(false);
  const { textSearch } = useParams();
  const dispatch = useDispatch();
  const dataAcademy = useSelector(state => state.academyInfo);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    dispatch(
      academyDataActions.showBanner({
        showBanner: true
      })
    );
  }, []);

  useEffect(() => {
    if (dataAcademy.data.academyName) {
      dispatch(
        getCoursesByAcademy(
          dataAcademy.data.idAcademy,
          3,
          textSearch
        )
      );
    }
    if (dataAcademy.metadata) {
      setOpenDialog(true);
    }
  }, [dataAcademy.data, textSearch, dispatch]);

  useEffect(() => {
    if (dataAcademy.metadata) {
      setOpenDialog(true);
    }
  }, [dataAcademy.metadata, dispatch]);

  useEffect(() => {
    if (dataAcademy.courses.length > 0) {
      setIsLoading(false);
    }

    ReactGA.initialize(
      [
        {
          trackingId: 'G-5883QCZJX8',
          gaOptions: {
            name: 'trackerMayahii'
          }
        },
        {
          trackingId: `${dataAcademy.data.analitycs}`,
          gaOptions: { name: 'trackerUser' }
        }
      ],
      { debug: false }
    );

    if (textSearch) {
      ReactGA.send({
        hitType: 'pageview',
        page: `/${dataAcademy.data.shortName}/searchCourses/${textSearch}`,
        title: `/${dataAcademy.data.shortName}/searchCourses/${textSearch}`
      });
    } else {
      ReactGA.send({
        hitType: 'pageview',
        page: `/${dataAcademy.data.shortName}/`,
        title: `/${dataAcademy.data.shortName}/`
      });
    }
  }, [dataAcademy, textSearch]);

  const handleDelete = () => {
    window.location.href = `/${dataAcademy.data.shortName}`;
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  return (
    <section className={classes.coursesNav}>
      {textSearch && (
        <Chip
          className={classes.searchChip}
          label={textSearch}
          onDelete={handleDelete}
        />
      )}
      {isLoading && <Loading />}
      {!isLoading && (
        <ul className={classes.listCourses}>
          {dataAcademy.courses.map(course => (
            <li
              className={classes.itemCourses}
              key={course.idCourse}
            >
              <CourseCard
                typeOrg={dataAcademy.data.productType}
                courseData={course}
                idAcademy={dataAcademy.data.idAcademy}
              />
            </li>
          ))}
        </ul>
      )}
      {dataAcademy.metadata && (
        <MetadataModal
          open={openDialog}
          handleClose={handleClose}
          metadata={dataAcademy.metadata}
        />
      )}
    </section>
  );
};

export default Home;
